import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';
import { BarChartEmployeeComponent } from '../../../../pages/payroll/charts/bar-chart-employee/bar-chart-employee.component';
import { ChartsModule } from 'ng2-charts';

@NgModule({
	imports: [
		CommonModule,
		ChartsModule
	],
	exports: [
		BarChartComponent,
		DoughnutChartComponent,
		BarChartEmployeeComponent
	],
	declarations: [
		BarChartComponent,
		DoughnutChartComponent,
		BarChartEmployeeComponent
	]
})
export class WidgetChartsModule {}
